module.exports = __webpack_public_path__ + "img/music_thumbnail.ceeecd87.jpg";